import Vue from 'vue'
import title from './fragments/title'
import { mailto, whatsApp } from '@/util/catalog'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const creator = (data) => {
  const creator = data?.scheduled_by

  if (!creator) return ''

  return `
    <details>
      ${title(translate(area + 'scheduledBy'))}
      <content>
        <h6 class="text-uppercase grey--text">
          ${translate(area + 'name')}
        </h6>
        <p class="body-2 mb-3">
          ${creator.name}
        </p>

        <div class="row no-gutters">
          <div class="col mw-150">
            <h6 class="text-uppercase grey--text">
              ${translate(area + 'phone')}
            </h6>
            <p class="body-2 mb-3">
              ${whatsApp(creator.phone)}
            </p>
          </div>
          <div class="col">
            <h6 class="text-uppercase grey--text">
              ${translate(area + 'user')}
            </h6>
            <p class="body-2 mb-3">
              ${mailto(creator.username)}
            </p>
          </div>
        </div>
      </content>
    </details>
  `
}

export default creator
